import Vue from 'vue'
import Router from 'vue-router'
import MapPage from '../components/MapPage.vue'
import TianDiTuPage from '../components/TianDiTuPage.vue'
import OsmMapPage from '../components/OsmMapPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash', // 使用hash模式以支持静态部署
  routes: [
    {
      path: '/tMap',
      name: 'MapPage',
      component: MapPage,
      // 将所有查询参数传递给组件
      props: (route) => {
        const props = {}
        
        if (route.query.lng) props.lng = parseFloat(route.query.lng)
        if (route.query.lat) props.lat = parseFloat(route.query.lat)
        if (route.query.zoom) props.zoom = parseFloat(route.query.zoom)
        if (route.query.circleRadius) props.circleRadius = parseInt(route.query.circleRadius)
        if (route.query.myLng) props.myLng = parseFloat(route.query.myLng)
        if (route.query.myLat) props.myLat = parseFloat(route.query.myLat)
        if (route.query.inKqArea !== undefined) props.inKqArea = route.query.inKqArea === 'true'
        
        return props
      }
    },
    {
      path: '/tMapPoi',
      name: 'TianDiTuPage',
      component: TianDiTuPage,
      // 将所有查询参数传递给组件
      props: (route) => {
        const props = {}
        
        // 直接的参数
        if (route.query.lng) props.lng = parseFloat(route.query.lng)
        if (route.query.lat) props.lat = parseFloat(route.query.lat)
        if (route.query.zoom) props.zoom = parseFloat(route.query.zoom)
        if (route.query.tipsText) props.tipsText = route.query.tipsText
        
        return props
      }
    },
    {
      path: '/',
      name: 'OsmMapPage',
      component: OsmMapPage,
      // 将所有查询参数传递给组件
      props: (route) => {
        const props = {}
        
        if (route.query.lng) props.lng = parseFloat(route.query.lng)
        if (route.query.lat) props.lat = parseFloat(route.query.lat)
        if (route.query.zoom) props.zoom = parseFloat(route.query.zoom)
        if (route.query.circleRadius) props.circleRadius = parseInt(route.query.circleRadius)
        if (route.query.myLng) props.myLng = parseFloat(route.query.myLng)
        if (route.query.myLat) props.myLat = parseFloat(route.query.myLat)
        if (route.query.inKqArea !== undefined) props.inKqArea = route.query.inKqArea === 'true'
        
        return props
      }
    }
  ]
})